import { useState, useEffect, useCallback } from 'react';

const reEditEventHandlers = (item, eventhandlers) => {
  if (!eventhandlers) {
    return null;
  }
  const newEvents = {};
  for (const [key, value] of Object.entries(eventhandlers)) {
    newEvents[key] = function (event) {
      return value(event, item);
    };
  }
  return newEvents;
};

const useLeafletMarker = (pmarkers) => {
  const [data, setData] = useState({});
  const [markers, setMarkers] = useState([]);
  const prepare = useCallback((param) => {
    let properties = {};
    let tempData = [];
    if (param?.length > 0) {
      for (let index = 0; index < param?.length; index++) {
        const element = param[index];
        for (let index = 0; index < element?.items?.length; index++) {
          const mc = element?.markerCluster;
          const rp = element?.responsivePopup;
          const item = element.items[index];
          properties = { responsivePopup: rp, markerCluster: mc };
          if (element.tooltip && element.popup) {
            throw new Error('only one (choose tooltip or popup)');
          } else {
            if (element.tooltip) {
              let markerProps = {
                position: element.position(item),
                icon: element.icon(item),
                eventHandlers: reEditEventHandlers(item, element.eventHandlers),
                tooltip: {
                  ...element.tooltip,
                  content: element.tooltip.content(item),
                },
              };
              tempData.push(markerProps);
            } else if (element.popup) {
              let markerProps = {
                position: element.position(item),
                icon: element.icon(item),
                eventHandlers: reEditEventHandlers(item, element.eventHandlers),
                popup: element.popup(item),
              };
              tempData.push(markerProps);
            } else {
              let markerProps = {
                position: element.position(item),
                icon: element.icon(item),
                eventHandlers: reEditEventHandlers(item, element.eventHandlers),
              };
              tempData.push(markerProps);
            }
          }
        }
      }
    }
    setMarkers({ markers: tempData, properties: properties });
  }, []);
  useEffect(() => {
    if (pmarkers) {
      setData(pmarkers);
    }
  }, []);
  useEffect(() => {
    prepare(data);
  }, [data]);
  return { markers, setData };
};

export default useLeafletMarker;
